// src/services/ai.js

import api from "../utils/api";

const AiServices = {
    /**
     * Generates script for image using AI
     */
    getImageScriptByAI(payload){
        return api.post(`/ai/image/script`, payload);
    },

    /**
     * Generates tags for image using AI
     */
    getImageTagByAI(payload){
        return api.post(`/ai/image/tags`, payload);
    },

    /**
     * Gets all available AI domains
     */
    getAllDomains() {
        return api.get('/ai/domains');
    },

    /**
     * Additive Designer Agent create — does not replace Create Design / smart-campaign.
     * POST /ai/designer-create-draft → agentic /next/campaign/design/create-from-prompt
     */
    createDesignerDraft(payload) {
        return api.post('/ai/designer-create-draft', payload);
    },

    /**
     * Generates image from text using AI
     * @param payload
     * @returns {Promise<axios.AxiosResponse<any>>}
     */
    textToImage(payload) {
        return api.post('/media-enhancer/text-to-image', payload);
    },

    /**
     * Generates video from image using AI
     * @param payload
     * @returns {Promise<axios.AxiosResponse<any>>}
     */
    imageToVideo(payload) {
        return api.post('/media-enhancer/image-to-video', payload);
    },

    /**
     * Generates video from text using AI
     * @param payload
     * @returns {Promise<axios.AxiosResponse<any>>}
     */
    textToVideo(payload) {
        return api.post('/media-enhancer/text-to-video', payload);
    },

};

export default AiServices;